import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const List = lazy(() => import('./pages/List'));
const Edit = lazy(() => import('./pages/Edit'));
const Import = lazy(() => import('./pages/Import'));

export function SchemasRoutes() {
    return (
        <Routes>
            <Route path="schemas" element={<List />} />
            <Route path="schemas/create" element={<Edit />} />
            <Route path="schemas/edit/:id" element={<Edit />} />
            <Route path="schemas/copy/:id" element={<Edit />} />
            <Route path="schemas/import" element={<Import />} />

            <Route path="*" element={null} />
        </Routes>
    );
}
